import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';

import useQuery from 'app/hooks/useQuery';
import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    form: {
        maxWidth: '320px'
    },
    submit: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
}));

export default function LoginForm (props) {

    const [ username, setUsername ] = useState("");
    const [ password, setPassword ] = useState("");
    const [ showPassword, setShowPassword ] = useState(false);
    const [ errors, setErrors ] = useState({});

    const { app, handleApp, hydrateApp } = useApp();
    let query = useQuery();
    const api = useApi();

    const classes = useStyles();

    const { onLoading, loading } = props;

    useEffect(() => {

        const queryPrevious = query.get('previous');

        if (queryPrevious) {
            setPrevious(queryPrevious);
        }

    }, []);

    const handleUsername = e => {

        const value = e.target.value;

        if (isError("username")) delete errors.username;

        setUsername(value);
    };

    const handlePassword = e => {

        const value = e.target.value;

        if (isError("password")) delete errors.password;

        setPassword(value);
    };

    const handleShowPassword = () => {
        setShowPassword(!showPassword)
    };

    const postLogin = e => {
        e.preventDefault();

        onLoading(true);

        const data = {
            username: username,
            password: password,
        }

        api.post(process.env.MIX_WEB_BASEURL + '/login', data)
            .catch(error => {

                if (error?.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                }
                onLoading(false)
            });
    }

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    }

    return (
        <div className={classes.form}>
            <form noValidate onSubmit={postLogin}>
                <Typography component="div" align="center" variant="subtitle1" color="textSecondary" gutterBottom>
                    Welcome to {app.club ? app.club.name : 'Club Apps'}
                </Typography>
                <TextField
                    id="email"
                    label="Username or Email"
                    name="email"
                    value={username}
                    margin="normal"
                    onChange={handleUsername}
                    fullWidth
                    autoFocus
                    error={isError('username')}
                    helperText={getErrorMessage('username')}
                    variant="outlined"
                    color="secondary"
                />
                <FormControl
                    fullWidth
                    error={isError('password')}
                    variant="outlined"
                    margin="normal"
                    color="secondary"
                    >
                    <InputLabel htmlFor="password">Password</InputLabel>
                    <OutlinedInput
                        id="password"
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={handlePassword}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={handleShowPassword}
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                        labelWidth={70}
                    />
                    <FormHelperText id="password-error-text">{getErrorMessage('password')}</FormHelperText>
                </FormControl>
                {isError('general') &&
                    <Alert severity="error">{getErrorMessage('general')}</Alert>
                }
                <Grid container justify="space-between" alignItems="center" direction="row-reverse">
                    <Grid item>
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            className={classes.submit}
                            disabled={loading}
                            type="submit"
                            >
                            Next
                        </Button>
                    </Grid>
                    <Grid item>
                        {app.club ? (
                            <Typography variant="subtitle2" color="textSecondary">
                                Click <strong>NEXT</strong> to Log in.
                            </Typography>
                        ) : (
                            <Button
                                component={RouterLink}
                                to="/register"
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                className={classes.submit}
                                disabled={loading}
                                >
                                Register
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </form>
            <Typography component="div" align="center" variant="subtitle2" className={classes.marginTop}>
                <Link component={RouterLink} to="/support/login" color="secondary">
                    Forgot Username or Email?
                </Link>
                <br/>
                <Link component={RouterLink} to="/password/email" color="secondary">
                    Forgot Password?
                </Link>
            </Typography>
        </div>
    );
}
